module.exports = __webpack_public_path__ + "img/picture4.1c19a87e.jpg";